import { Injectable } from '@angular/core';
import { OAuthService, OAuthEvent } from 'angular-oauth2-oidc';
import { BehaviorSubject } from 'rxjs';
import { authConfig } from './auth.config';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private isAuthenticatedSubject = new BehaviorSubject<boolean>(false);
  public isAuthenticated$ = this.isAuthenticatedSubject.asObservable();

  constructor(private oauthService: OAuthService) {
    this.oauthService.configure(authConfig);
  }

  async initAuth(): Promise<any> {
    return new Promise<void>(async (resolve, reject) => {
      try {
        await this.oauthService.loadDiscoveryDocumentAndTryLogin();
        
        // Setup automatic silent refresh
        this.oauthService.setupAutomaticSilentRefresh();
        
        // Subscribe to token events
        this.oauthService.events.subscribe((event: OAuthEvent) => {
          if (event.type === 'token_received' || event.type === 'token_refreshed') {
            this.isAuthenticatedSubject.next(true);
          } else if (event.type === 'logout' || event.type === 'session_terminated') {
            this.isAuthenticatedSubject.next(false);
          }
        });

        this.isAuthenticatedSubject.next(this.oauthService.hasValidAccessToken());
        resolve();
      } catch (error) {
        console.error('Error initializing auth:', error);
        reject(error);
      }
    });
  }

  login() {
    this.oauthService.initLoginFlow();
  }

  logout() {
    this.oauthService.logOut();
  }

  getAccessToken(): string {
    return this.oauthService.getAccessToken();
  }

  getUserClaims(): any {
    return this.oauthService.getIdentityClaims();
  }

  isAuthenticated(): boolean {
    return this.oauthService.hasValidAccessToken();
  }
} 